import styled from 'styled-components/macro';

import Button from '../Button';

const Item = styled(Button)`
  position: relative;
  height: 59px;
  padding: 5px 0;
  font-size: 10px;
  color: #fff;
  border-bottom: 2px solid transparent;
  opacity: 0.4;
  transition: opacity 0.25s ease-out;

  svg {
    opacity: 0.6;
    transition: opacity 0.25s ease-out;
  }

  &:hover {
    opacity: 1;

    svg {
      opacity: 1;
    }
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
`;

export default Item;
